module.exports = __webpack_public_path__ + "img/MAX-logo.ed9791ec.svg";